import Check from "@material-symbols/svg-500/rounded/check.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const CheckIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Check });
	return <Icon />;
};

export default memo(CheckIcon);
